import * as turf from "@turf/turf";
import { appManager } from "../../AppManager";
import { Dictionary } from "../../shared/Dictionary";
import { HashSetNumber } from "../../shared/HashSetNumber";
import "@birkskyum/maplibre-gl-draw/_dist/src/feature_types/feature";
export class RoutingFacade {
    async getRoutesAsFeatureCollection(options, signal) {
        const postOptions = {
            profile: options.profile,
            origins: [options.locations[0]],
            destinations: [options.locations[1]],
            branchCommitId: options.branchCommitId,
            maxIncrease: options.maxIncrease,
        };
        const response = await appManager.api.publish.postRoutesForBranchCommit(postOptions, signal);
        if (!response.success)
            throw Error(response.error);
        return this.toFeatureCollection(response.data);
    }
    toFeatureCollection(routeResponse) {
        // index cuts per segment.
        const segmentCuts = new Dictionary();
        routeResponse.routes.forEach(to => {
            to.forEach(alternatives => {
                alternatives.forEach(alternative => {
                    alternative.segments.forEach(segment => {
                        let cuts = segmentCuts.get(segment.id);
                        if (typeof cuts === "undefined") {
                            cuts = { forward: new HashSetNumber(), backward: new HashSetNumber() };
                            segmentCuts.set(segment.id, cuts);
                        }
                        if (segment.forward) {
                            cuts.forward.set(segment.tailOffset ?? 0);
                            cuts.forward.set(segment.headOffset ?? 65536);
                        }
                        else {
                            cuts.backward.set(segment.tailOffset ?? 0);
                            cuts.backward.set(segment.headOffset ?? 65536);
                        }
                    });
                });
            });
        });
        const segmentsFeatures = new Dictionary();
        segmentCuts.forEach((segmentId, cuts) => {
            const segment = routeResponse.segments[segmentId];
            if (typeof segment === "undefined")
                throw Error("Segment not in response");
            segmentsFeatures[segmentId] = {
                forward: this.buildFeaturesForSegment(segment, cuts.forward, true),
                backward: this.buildFeaturesForSegment(segment, cuts.backward, false),
            };
        });
        // TODO: details to every route
        // // add route details to each feature.
        // routeResponse.routes.forEach((to, f) => {
        //     to.forEach((alternatives, t) => {
        //         alternatives.forEach((alternative, a) => {
        //             alternative.segments.forEach(segment => {
        //                 const segmentFeatures = segment.forward ? segmentsFeatures[segment.id].forward : segmentsFeatures[segment.id].backward;
        //
        //
        //                 const segmentPartKey = this.buildSegmentPartKey(segment.id, segment.forward, segment.tailOffset ?? 0, segment.headOffset ?? 65536);
        //                 const segmentFeature = segmentFeatures.get(segmentPartKey);
        //                 if (typeof segmentFeature === "undefined") return; //throw new Error("Segment part not in response");
        //
        //                 segmentFeature.properties[`_route_${f}_${t}_${a}`] = true;
        //             });
        //         });
        //     });
        // });
        const features = [];
        segmentsFeatures.forEach((_, segmentFeatures) => {
            segmentFeatures.forward.forEach(featureAndOffsets => {
                features.push(featureAndOffsets.feature);
            });
            segmentFeatures.backward.forEach(featureAndOffsets => {
                features.push(featureAndOffsets.feature);
            });
        });
        return turf.featureCollection(features);
    }
    buildFeaturesForSegment(segment, cuts, forward) {
        const featureParts = [];
        let lineString = turf.lineString(segment.shape);
        if (!forward) {
            const reversedCoordinates = [...segment.shape];
            reversedCoordinates.reverse();
            lineString = turf.lineString(reversedCoordinates);
        }
        const length = turf.length(lineString);
        const forwardCuts = cuts.entries().sort((n1, n2) => n1 - n2);
        for (let i = 1; i < forwardCuts.length; i++) {
            const tailOffset = forwardCuts[i - 1];
            const headOffset = forwardCuts[i];
            let partLineString = lineString;
            if (tailOffset > 0 || headOffset < 65536) {
                const tailLength = (tailOffset / 65536.0) * length;
                const headLength = (headOffset / 65536.0) * length;
                partLineString = turf.lineSliceAlong(lineString, tailLength, headLength);
            }
            // copy attributes.
            const properties = {};
            for (const key in segment.attributes) {
                properties[key] = segment.attributes[key];
            }
            // set global properties.
            // properties["_id"] = segment.id;
            properties["_forward"] = forward;
            properties["_tail_offset"] = tailOffset;
            properties["_head_offset"] = headOffset;
            featureParts.push({
                feature: turf.feature(partLineString.geometry, properties),
                tailOffset: tailOffset,
                headOffset: headOffset,
            });
        }
        return featureParts;
    }
}
